import { ArrowUpIcon, ArrowDownIcon, MinusIcon, type LucideIcon } from 'lucide-react';

export interface PriorityConfig {
  /** Tailwind text-color class, e.g. `text-red-950` */
  textColor: string;
  /** Tailwind background-color class for cards, e.g. `bg-red-50` */
  cardBg: string;
  /** Tailwind background-color class for pills, e.g. `bg-red-200` */
  pillBg: string;
  icon: LucideIcon;
}

/**
 * Each level pairs a tint with the text colour that reads on it, in both themes. They are
 * fixed palette steps rather than semantic tokens, because the design names the colours
 * directly and the library has no equivalents; keeping each pair together, dark variant
 * included, is what stops a foreground from one theme landing on a tint from the other.
 *
 * Yellow rather than Tessra's amber in dark: amber's deep steps read as brown.
 *
 * The pill sits a step apart from the card it sits on (darker in light, lighter in dark), so
 * it stays legible as a pill rather than dissolving into the box.
 */
export const PRIORITY_CONFIG: Record<string, PriorityConfig> = {
  high: {
    textColor: 'text-red-950 dark:text-badge-red-foreground',
    cardBg: 'bg-red-50 dark:bg-red-950',
    pillBg: 'bg-red-200 dark:bg-badge-red',
    icon: ArrowUpIcon,
  },
  medium: {
    textColor: 'text-yellow-900 dark:text-badge-yellow-foreground',
    cardBg: 'bg-yellow-50 dark:bg-yellow-950',
    pillBg: 'bg-yellow-200 dark:bg-badge-yellow',
    icon: MinusIcon,
  },
  low: {
    textColor: 'text-gray-800 dark:text-secondary-foreground',
    cardBg: 'bg-gray-50 dark:bg-secondary/40',
    pillBg: 'bg-gray-200 dark:bg-secondary',
    icon: ArrowDownIcon,
  },
};
